import axios from 'axios'
import { holdActionResult, HOLD_ACTION_REQUEST } from '@/service/program/invoice'

export const FUNDING_APPROVALS_URL = '/funding-approvals';

// For reads whose errors the caller shows inline: skip the interceptor's global error flash.
export const QUIET_REQUEST = { suppressErrorFlash: true };

// Both resolve to the row or { errors } where errors is always a string to show inline.
export const getFundingApproval = async (id) => {
    try {
        const response = await axios.get(`${FUNDING_APPROVALS_URL}/${id}`, HOLD_ACTION_REQUEST);
        return holdActionResult(response);
    } catch (e) {
        return holdActionResult(e?.response);
    }
};

export const approveFunding = async (organizationId, programId, holdId, notes) => {
    try {
        const response = await axios.post(
          `/organization/${organizationId}/program/${programId}/deposit-holds/${holdId}/approve`,
          { notes: notes || null },
          HOLD_ACTION_REQUEST
        );
        return holdActionResult(response);
    } catch (e) {
        return holdActionResult(e?.response);
    }
};
